import React, { useState } from 'react';
import clsx from 'clsx';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

import Avatar from 'components/Avatar';
import { imagePickSize } from 'utils/general';
import './org-member-card.scss';

const Card = (props) => {
  const {
    loginId,
    checked,
    firstname,
    lastname,
    initials,
    profileImage,
    orgId,
    orgLeadContact,
    setMember,
    unsetMember,
  } = props || {};

  const iconSize = '27px';
  let imagePath = null;
  if (profileImage) {
    imagePath = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(
      profileImage,
      'square60',
    )}`;
  }

  const [isActive, setActive] = useState(false);

  const handleClick = async (e) => {
    e.stopPropagation();
    if (checked) {
      await unsetMember({ loginId, orgId, orgLeadContact });
    }
    else {
      await setMember({ loginId, orgId });
    }
  };

  const truncate = (str, n) => {
    return (str.length > n) ? `${str.slice(0, n-1)}...` : str;
  };

  return (
    <div className="column">
      <button
        className={clsx(
          'ap-dropdown__button',
          'button--unstyled',
          'ap-dropdown__button--lead-assignment',
          'lead-setting__status',
          'lead-setting__status-card',
          { 'selected': checked },
        )}
        onClick={handleClick}
        onMouseEnter={() => setActive(true)}
        onMouseMove={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
      >
        <div className="inline-avatar">
          <div className="inline-avatar__image">
            <Avatar
              photo={imagePath}
              text={!imagePath ? initials : null}
              size={30}
              borderSize={1}
            />
          </div>
          <div className="inline-avatar__info">
            {truncate(`${firstname} ${lastname}`, 16)}
          </div>
        </div>
        <div
          className={clsx('inline-icon', {
            'selected': checked,
          })}
        >
          <CheckCircleOutlinedIcon
            style={{
              fontSize: iconSize,
              opacity: checked ? 1 : 0.3,
              color: checked ? '#bea06e' : isActive ? '#a7a7a7' : 'transparent',
            }}
          />
        </div>
      </button>
    </div>
  );
};

export default Card;
